module.exports = __webpack_public_path__ + "static/media/52.53a755fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/52.png
// module id = 625
// module chunks = 0